 
import {useRef, useEffect, useState} from "react";
import {TooltipHost, DirectionalHint} from "@fluentui/react";
import styles from "./Example.module.css";

interface Props {
    text: string;
    value: string;
    onClick: (value: string) => void;
}

export const Example = ({text, value, onClick}: Props) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const [isClamped, setIsClamped] = useState(false);

    useEffect(() => {
        const el = textRef.current;
        if (!el) return;

        const observer = new ResizeObserver(() =>
            // CSS line-clamp visually truncates text but doesn't affect the DOM —
            // scrollHeight still reflects the full content height while clientHeight
            // reflects only the visible area. This mismatch is the only reliable way
            // to detect whether the clamp is actually active at the current container width.
            setIsClamped(el.scrollHeight > el.clientHeight)
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [text]);

    // Only render a tooltip if the text is actually clamped, to avoid unnecessary tooltips on hover.
    return (
        <TooltipHost
            content={isClamped ? value : undefined}
            directionalHint={DirectionalHint.bottomCenter}
        >
            <div className={styles.example} onClick={() => onClick(value)}>
                <p ref={textRef} className={styles.exampleText}>
                    {text}
                </p>
            </div>
        </TooltipHost>
    );
};
